<template>
    <div>
        <div v-if="isLoading" class="loading-overlay">
            <div class="spinner"></div>
        </div>
        
        <!-- Info Banner -->
        <div class="form-info-banner">
            <h3 class="form-info-banner-title">Os campos com * são de preenchimento obrigatório</h3>
            <p class="form-info-banner-text">Caso queira, você poderá salvar e continuar depois.</p>
        </div>
        
        <!-- Seção: Endereço Residencial -->
        <section class="form-section">
            <div class="form-section-header">
                <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Endereço residencial'"
                    :Sessao="'Endereço'" :SubSessao="'Endereço residencial'" />
            </div>
            <div class="form-section-content">
                <div class="form-subsection">
                    <h4 class="form-subsection-title">
                        <i class="fa fa-map-marker"></i>
                        Localização
                    </h4>
                    <div class="form-grid-12">
                        <div class="col-span-3 form-field">
                            <div class="flex items-center justify-between">
                                <label class="form-field-label form-field-label-required" for="cep">CEP</label>
                                <a target="_blank" class="form-link text-xs"
                                    href="https://buscacepinter.correios.com.br/app/endereco/index.php">Não sei o CEP</a>
                            </div>
                            <input class="field" type="text" id="cep" placeholder="" v-model="localPF.Cep"
                                @change="salvarAlteracoesLocalmente(); validarCep(localPF)">
                            <p v-if="camposObrigatorios.erroEnderecoCep" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="col-span-7 form-field">
                            <label class="form-field-label form-field-label-required" for="endereco">Endereço/Logradouro</label>
                            <input class="field" type="text" :disabled="isDisabledEnderecoLogradouro" id="endereco"
                                @change="salvarAlteracoesLocalmente" v-model="localPF.Logradouro" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoLogradouro" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="col-span-2 form-field">
                            <label class="form-field-label form-field-label-required" for="numero">Número</label>
                            <input class="field" type="text" id="numero" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.LogradouroNumero" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoNumero" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="form-grid-3">
                        <div class="form-field">
                            <label class="form-field-label" for="complemento">Complemento</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.LogradouroComplemento" id="complemento" placeholder="">
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="bairro">Bairro</label>
                            <input class="field" type="text" :disabled="isDisabledEnderecoLogradouro" v-model="localPF.Bairro"
                                @change="salvarAlteracoesLocalmente" id="bairro" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoBairro" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="form-grid-3">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="cidade">Cidade</label>
                            <input class="field" type="text" :disabled="isDisabledEndereco" v-model="localPF.Cidade"
                                @change="salvarAlteracoesLocalmente" id="cidade" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoCidade" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="uf">UF</label>
                            <select id="uf" @change="salvarAlteracoesLocalmente" v-model="localPF.Uf" class="field">
                                <option value="">Selecione</option>
                                <option v-for="uf in ufs" :key="uf" :value="uf">
                                    {{ uf }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroEnderecoUf" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="pais">País</label>
                            <select id="pais" @change="salvarAlteracoesLocalmente" class="field" v-model="localPF.LogradouroPais">
                                <option value="">Selecione</option>
                                <option v-for="item in listaPaises" :key="item.Codigo" :value="item.Codigo">
                                    {{ item.Descricao }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroEnderecoPais" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="form-grid-1">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required">Esse endereço é o mesmo de correspondência?</label>
                            <div class="form-radio-group">
                                <label class="form-radio-item">
                                    <input type="radio" value="1" name="EnderecoCorrespondencia" class="form-radio-input"
                                        v-model="localPF.EnderecoCorrespondencia"
                                        @change="salvarAlteracoesLocalmenteLimpandoEnderecoCorrespondencia" />
                                    <span class="form-radio-label">Sim</span>
                                </label>
                                <label class="form-radio-item">
                                    <input type="radio" value="2" name="EnderecoCorrespondencia" class="form-radio-input"
                                        v-model="localPF.EnderecoCorrespondencia" @change="salvarAlteracoesLocalmente" />
                                    <span class="form-radio-label">Não</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
        <!-- Seção: Endereço de Correspondência (condicional) -->
        <section v-if="localPF.EnderecoCorrespondencia == 2" class="form-section">
            <div class="form-section-header">
                <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Endereço correspondência'"
                    :Sessao="'Endereço'" :SubSessao="'Endereço correspondência'" />
            </div>
            <div class="form-section-content">
                <div class="form-subsection">
                    <h4 class="form-subsection-title">
                        <i class="fa fa-envelope"></i>
                        Localização
                    </h4>
                    <div class="form-grid-12">
                        <div class="col-span-3 form-field">
                            <div class="flex items-center justify-between">
                                <label class="form-field-label form-field-label-required" for="cepOutro">CEP</label>
                                <a target="_blank" class="form-link text-xs"
                                    href="https://buscacepinter.correios.com.br/app/endereco/index.php">Não sei o CEP</a>
                            </div>
                            <input class="field" type="text" id="cepOutro" placeholder="" v-model="localPF.CepOutro"
                                @change="salvarAlteracoesLocalmente(); validarCepOutro(localPF)">
                            <p v-if="camposObrigatorios.erroEnderecoOutroCep" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="col-span-7 form-field">
                            <label class="form-field-label form-field-label-required" for="enderecoOutro">Endereço/Logradouro</label>
                            <input class="field" type="text" :disabled="isDisabledEnderecoOutroLogradouro" id="enderecoOutro"
                                @change="salvarAlteracoesLocalmente" v-model="localPF.LogradouroOutro" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoOutroLogradouro" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="col-span-2 form-field">
                            <label class="form-field-label form-field-label-required" for="numeroOutro">Número</label>
                            <input class="field" type="text" id="numeroOutro" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.LogradouroNumeroOutro" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoOutroNumero" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="form-grid-3">
                        <div class="form-field">
                            <label class="form-field-label" for="complementoOutro">Complemento</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.LogradouroComplementoOutro" id="complementoOutro" placeholder="">
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="bairroOutro">Bairro</label>
                            <input class="field" type="text" :disabled="isDisabledEnderecoOutroLogradouro"
                                @change="salvarAlteracoesLocalmente" v-model="localPF.BairroOutro" id="bairroOutro"
                                placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoOutroBairro" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="form-grid-3">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="cidadeOutro">Cidade</label>
                            <input class="field" type="text" :disabled="isDisabledEnderecoOutro"
                                @change="salvarAlteracoesLocalmente" v-model="localPF.CidadeOutro" id="cidadeOutro"
                                placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoOutroCidade" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="ufOutro">UF</label>
                            <select id="ufOutro" @change="salvarAlteracoesLocalmente" v-model="localPF.UfOutro" class="field"
                                :disabled="isDisabledEnderecoOutro">
                                <option value="">Selecione</option>
                                <option v-for="uf in ufs" :key="uf" :value="uf">
                                    {{ uf }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroEnderecoOutroUf" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="paisOutro">País</label>
                            <select id="paisOutro" @change="salvarAlteracoesLocalmente" class="field"
                                v-model="localPF.PaisOutro">
                                <option value="">Selecione</option>
                                <option v-for="item in listaPaises" :key="item.Codigo" :value="item.Codigo">
                                    {{ item.Descricao }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroEnderecoOutroPais" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
        <!-- Seção: Endereço Comercial -->
        <section class="form-section">
            <div class="form-section-header">
                <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Endereço comercial'"
                    :Sessao="'Endereço'" :SubSessao="'Endereço comercial'" />
            </div>
            <div class="form-section-content">
                <div class="form-subsection">
                    <h4 class="form-subsection-title">
                        <i class="fa fa-briefcase"></i>
                        Localização
                    </h4>
                    <div class="form-grid-12">
                        <div class="col-span-3 form-field">
                            <div class="flex items-center justify-between">
                                <label class="form-field-label" for="cepComercial">CEP</label>
                                <a target="_blank" class="form-link text-xs"
                                    href="https://buscacepinter.correios.com.br/app/endereco/index.php">Não sei o CEP</a>
                            </div>
                            <input class="field" type="text" id="cepComercial" placeholder=""
                                @change="salvarAlteracoesLocalmente(); validarCepComercial(localPF)"
                                v-model="localPF.EnderecoComercialCep">
                            <p v-if="camposObrigatorios.erroEnderecoComercialCep" class="form-field-error">
                                Remova ou complete o preenchimento do endereço comercial.
                            </p>
                        </div>
                        <div class="col-span-7 form-field">
                            <label class="form-field-label" for="enderecoComercial">Endereço/Logradouro</label>
                            <input class="field" type="text" :disabled="isDisabledEnderecoComercialLogradouro"
                                id="enderecoComercial" @change="salvarAlteracoesLocalmente" v-model="localPF.EnderecoComercial"
                                placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoComercialLogradouro" class="form-field-error">
                                Remova ou complete o preenchimento do endereço comercial.
                            </p>
                        </div>
                        <div class="col-span-2 form-field">
                            <label class="form-field-label" for="numeroComercial">Número</label>
                            <input class="field" type="text" id="numeroComercial" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.EnderecoComercialNumero" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoComercialNumero" class="form-field-error">
                                Remova ou complete o preenchimento do endereço comercial.
                            </p>
                        </div>
                    </div>
                    <div class="form-grid-3">
                        <div class="form-field">
                            <label class="form-field-label" for="complementoComercial">Complemento</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.EnderecoComercialComplemento" id="complementoComercial" placeholder="">
                        </div>
                        <div class="form-field">
                            <label class="form-field-label" for="bairroComercial">Bairro</label>
                            <input class="field" type="text" :disabled="isDisabledEnderecoComercialLogradouro"
                                @change="salvarAlteracoesLocalmente" v-model="localPF.EnderecoComercialBairro"
                                id="bairroComercial" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoComercialBairro" class="form-field-error">
                                Remova ou complete o preenchimento do endereço comercial.
                            </p>
                        </div>
                    </div>
                    <div class="form-grid-3">
                        <div class="form-field">
                            <label class="form-field-label" for="cidadeComercial">Cidade</label>
                            <input class="field" type="text" :disabled="isDisabledEnderecoComercial"
                                @change="salvarAlteracoesLocalmente" v-model="localPF.EnderecoComercialCidade"
                                id="cidadeComercial" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoComercialCidade" class="form-field-error">
                                Remova ou complete o preenchimento do endereço comercial.
                            </p>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label" for="ufComercial">UF</label>
                            <select id="ufComercial" :disabled="isDisabledEnderecoComercial" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.EnderecoComercialEstado" class="field">
                                <option value="">Selecione</option>
                                <option v-for="uf in ufs" :key="uf" :value="uf">
                                    {{ uf }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroEnderecoComercialUf" class="form-field-error">
                                Remova ou complete o preenchimento do endereço comercial.
                            </p>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label" for="paisComercial">País</label>
                            <select id="paisComercial" @change="salvarAlteracoesLocalmente" class="field"
                                v-model="localPF.EnderecoComercialPais">
                                <option value="">Selecione</option>
                                <option v-for="item in listaPaises" :key="item.Codigo" :value="item.Codigo">
                                    {{ item.Descricao }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroEnderecoComercialPais" class="form-field-error">
                                Remova ou complete o preenchimento do endereço comercial.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
        <ModalAlerta 
            :mostrar="modalAlerta.mostrar"
            :tipo="modalAlerta.tipo"
            :titulo="modalAlerta.titulo"
            :mensagem="modalAlerta.mensagem"
            @fechar="modalAlerta.mostrar = false"
        />
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import LabelDisclaimer from '@/components/LabelDisclaimer.vue'
import { validarCampoCep, ufs } from '@/utils/formUtils';
import ModalAlerta from '../Utilitarios/ModalAlerta.vue';

export default {
    name: 'CadastroPF_Endereco',
    props: ['informacoesBasicas', 'Edicao'],
    components: { LabelDisclaimer, ModalAlerta },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            etapaCadastro: 'GET_ETAPA_CADASTRO',
            infoBasicas: 'GET_PF_INFO_BASICAS',
            listaPaises: 'GET_LISTA_PAISES',
        }),
        ufs() {
            return ufs;
        },
    },
    data() {
        return {
            modalAlerta: {
                mostrar: false,
                tipo: 'warning',
                titulo: '',
                mensagem: ''
            },
            camposObrigatorios: {
                erroEnderecoCep: false,
                erroEnderecoLogradouro: false,
                erroEnderecoNumero: false,
                erroEnderecoBairro: false,
                erroEnderecoCidade: false,
                erroEnderecoUf: false,
                erroEnderecoPais: false,
                erroEnderecoOutroCep: false,
                erroEnderecoOutroLogradouro: false,
                erroEnderecoOutroNumero: false,
                erroEnderecoOutroBairro: false,
                erroEnderecoOutroCidade: false,
                erroEnderecoOutroUf: false,
                erroEnderecoOutroPais: false,
                erroEnderecoComercialCep: false,
                erroEnderecoComercialLogradouro: false,
                erroEnderecoComercialNumero: false,
                erroEnderecoComercialBairro: false,
                erroEnderecoComercialCidade: false,
                erroEnderecoComercialUf: false,
                erroEnderecoComercialPais: false,
            },
            isDisabledEndereco: true,
            isDisabledEnderecoComercial: true,
            isDisabledEnderecoOutro: true,
            isDisabledEnderecoLogradouro: true,
            isDisabledEnderecoOutroLogradouro: true,
            isDisabledEnderecoComercialLogradouro: true,
            localPF: this.informacoesBasicas,
            permitirAvancar: false,
            isLoading: false,
        }
    },
    created() {
        this.validarCep(this.localPF, true);
        if (this.localPF.EnderecoCorrespondencia == 2) this.validarCepOutro(this.localPF, true);
        this.validarCepComercial(this.localPF, true);
    },
    mounted() {
        if (this.localPF != null) {
            this.localPF.EnderecoCorrespondencia = this.informacoesBasicas.CepOutro != '' && this.localPF.CepOutro != null ? 2 : 1;
        }
        this.validarFormulario();
    },
    methods: {
        salvarAlteracoesLocalmenteLimpandoEnderecoCorrespondencia() {
            this.localPF.LogradouroOutro = null;
            this.localPF.BairroOutro = null;
            this.localPF.CidadeOutro = null;
            this.localPF.UfOutro = null;
            this.localPF.PaisOutro = null;
            this.localPF.CepOutro = null;
            this.salvarAlteracoesLocalmente();
        },
        proximaEtapa() {
            if (this.validarFormulario(true)) {
                this.$store.commit('SET_ETAPA_CADASTRO', 5);
                this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
                this.salvarInformacoes();
            }
        },
        salvarInformacoes() {
            this.$store.commit('SET_PF_SALVAR_INFO', true);
        },
        salvarAlteracoesLocalmente() {
            this.$store.commit('SET_PF_SALVAR_INFO_ENDERECO', this.localPF);
            this.validarFormulario(false);
        },
        validarFormulario(submeter) {
            this.permitirAvancar = true;
            var nomeDoCampo = '';
            this.camposObrigatorios = {
                erroEnderecoCep: false,
                erroEnderecoLogradouro: false,
                erroEnderecoNumero: false,
                erroEnderecoBairro: false,
                erroEnderecoCidade: false,
                erroEnderecoUf: false,
                erroEnderecoPais: false,
                erroEnderecoOutroCep: false,
                erroEnderecoOutroLogradouro: false,
                erroEnderecoOutroNumero: false,
                erroEnderecoOutroBairro: false,
                erroEnderecoOutroCidade: false,
                erroEnderecoOutroUf: false,
                erroEnderecoOutroPais: false,
                erroEnderecoComercialCep: false,
                erroEnderecoComercialLogradouro: false,
                erroEnderecoComercialNumero: false,
                erroEnderecoComercialBairro: false,
                erroEnderecoComercialCidade: false,
                erroEnderecoComercialUf: false,
                erroEnderecoComercialPais: false,
            };
            if (!this.localPF.Cep) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoCep = true;
                    nomeDoCampo = 'CEP do Endereço Principal';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.Logradouro) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoLogradouro = true;
                    nomeDoCampo = 'Logradouro do Endereço Principal';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.LogradouroNumero) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoNumero = true;
                    nomeDoCampo = 'Número do Endereço Principal';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.Bairro) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoBairro = true;
                    nomeDoCampo = 'Bairro do Endereço Principal';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.Cidade) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoCidade = true;
                    nomeDoCampo = 'Cidade do Endereço Principal';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.Uf) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoUf = true;
                    nomeDoCampo = 'Uf do Endereço Principal';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.LogradouroPais) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoPais = true;
                    nomeDoCampo = 'País do Endereço Principal';
                }
                this.permitirAvancar = false;
            }

            if (!this.localPF.CepOutro && this.localPF.EnderecoCorrespondencia == 2) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoOutroCep = true;
                    nomeDoCampo = 'CEP do Endereço de Correspondência';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.LogradouroOutro && (this.localPF.CepOutro && this.localPF.EnderecoCorrespondencia == 2)) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoOutroLogradouro = true;
                    nomeDoCampo = 'Logradouro do Endereço de Correspondência';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.LogradouroNumeroOutro && (this.localPF.CepOutro && this.localPF.EnderecoCorrespondencia == 2)) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoOutroNumero = true;
                    nomeDoCampo = 'Número do Endereço de Correspondência';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.BairroOutro && (this.localPF.CepOutro && this.localPF.EnderecoCorrespondencia == 2)) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoOutroBairro = true;
                    nomeDoCampo = 'Bairro do Endereço de Correspondência';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.CidadeOutro && (this.localPF.CepOutro && this.localPF.EnderecoCorrespondencia == 2)) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoOutroCidade = true;
                    nomeDoCampo = 'Cidade do Endereço de Correspondência';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.UfOutro && (this.localPF.CepOutro && this.localPF.EnderecoCorrespondencia == 2)) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoOutroUf = true;
                    nomeDoCampo = 'Uf do Endereço de Correspondência';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.PaisOutro && (this.localPF.CepOutro && this.localPF.EnderecoCorrespondencia == 2)) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoOutroPais = true;
                    nomeDoCampo = 'País do Endereço de Correspondência';
                }
                this.permitirAvancar = false;
            }

            const end = this.localPF;

            const campos = {
                cep: end.EnderecoComercialCep,
                logradouro: end.EnderecoComercial,
                numero: end.EnderecoComercialNumero,
                bairro: end.EnderecoComercialBairro,
                cidade: end.EnderecoComercialCidade,
                estado: end.EnderecoComercialEstado,
                pais: end.EnderecoComercialPais
            };

            const labels = {
                cep: 'CEP do Endereço Comercial',
                logradouro: 'Logradouro do Endereço Comercial',
                numero: 'Número do Endereço Comercial',
                bairro: 'Bairro do Endereço Comercial',
                cidade: 'Cidade do Endereço Comercial',
                estado: 'UF do Endereço Comercial',
                pais: 'País do Endereço Comercial'
            };

            // 1️⃣ tem pelo menos um preenchido?
            const algumCampoEEnderecoComercialPreenchido = Object.values(campos).some(v => !!v);

            if (algumCampoEEnderecoComercialPreenchido) {

                // 2️⃣ valida todos
                if (!campos.cep) {
                    if (submeter && this.permitirAvancar){
                        this.camposObrigatorios.erroEnderecoComercialCep = true;
                        nomeDoCampo = labels.cep;
                    } 
                    this.permitirAvancar = false;
                }

                if (!campos.logradouro) {
                    if (submeter && this.permitirAvancar){
                        this.camposObrigatorios.erroEnderecoComercialLogradouro = true;
                        nomeDoCampo = labels.logradouro;
                    } 
                    this.permitirAvancar = false;
                }

                if (!campos.numero) {
                   if (submeter && this.permitirAvancar){
                        this.camposObrigatorios.erroEnderecoComercialNumero = true;
                        nomeDoCampo = labels.numero;
                    } 
                    this.permitirAvancar = false;
                }

                if (!campos.bairro) {
                   if (submeter && this.permitirAvancar){
                        this.camposObrigatorios.erroEnderecoComercialBairro = true;
                        nomeDoCampo = labels.bairro;
                    } 
                    this.permitirAvancar = false;
                }

                if (!campos.cidade) {
                   if (submeter && this.permitirAvancar){
                        this.camposObrigatorios.erroEnderecoComercialCidade = true;
                        nomeDoCampo = labels.cidade;
                    } 
                    this.permitirAvancar = false;
                }

                if (!campos.estado) {
                   if (submeter && this.permitirAvancar){
                        this.camposObrigatorios.erroEnderecoComercialUf = true;
                        nomeDoCampo = labels.estado;
                    } 
                    this.permitirAvancar = false;
                }

                if (!campos.pais) {
                   if (submeter && this.permitirAvancar){
                        this.camposObrigatorios.erroEnderecoComercialPais = true;
                        nomeDoCampo = labels.pais;
                    } 
                    this.permitirAvancar = false;
                }
            }

            if (nomeDoCampo != '' && submeter) {
                this.modalAlerta = {
                    mostrar: true,
                    tipo: 'warning',
                    titulo: 'Atenção: Campo obrigatório',
                    mensagem: `O campo ${nomeDoCampo} não foi informado, preencha a informação para avançar.`
                };
            }

            return this.permitirAvancar;
        },
        async validarCep(objDados, somenteValidar = false) {
            this.isLoading = true;
            try {
                if (objDados.Cep) {
                    var result = await validarCampoCep(objDados, { somenteValidar: somenteValidar });
                    if (result) {
                        this.localPF.LogradouroPais = 'BRA';
                        this.isDisabledEndereco = true;
                        this.isDisabledEnderecoLogradouro = true;
                        if (objDados.Logradouro == '') {
                            this.isDisabledEnderecoLogradouro = false;
                        }
                    } else {
                        this.isDisabledEndereco = false;
                        this.isDisabledEnderecoLogradouro = false;
                    }
                } else if (!somenteValidar) {
                    objDados.Logradouro = '';
                    objDados.Bairro = '';
                    objDados.Cidade = '';
                    objDados.Uf = '';
                    objDados.LogradouroPais = '';

                    this.camposObrigatorios.erroEnderecoCep = false;
                    this.camposObrigatorios.erroEnderecoLogradouro = false;
                    this.camposObrigatorios.erroEnderecoBairro = false;
                    this.camposObrigatorios.erroEnderecoCidade = false;
                    this.camposObrigatorios.erroEnderecoUf = false;
                    this.camposObrigatorios.erroEnderecoPais = false;

                    this.isDisabledEndereco = false;
                    this.isDisabledEnderecoLogradouro = false;
                }
            } finally {
                this.isLoading = false;
            }
        },
        async validarCepOutro(objDados, somenteValidar = false) {
            this.isLoading = true;
            try {
                if (objDados.CepOutro) {
                    var result = await validarCampoCep(objDados, { somenteValidar: somenteValidar, tipoEndereco: "Outro" });
                    if (result) {
                        this.localPF.PaisOutro = 'BRA';
                        this.isDisabledEnderecoOutro = true;
                        this.isDisabledEnderecoOutroLogradouro = true;
                        if (objDados.LogradouroOutro == '')
                            this.isDisabledEnderecoOutroLogradouro = false;
                    } else {
                        this.isDisabledEnderecoOutro = false;
                        this.isDisabledEnderecoOutroLogradouro = false;
                    }
                } else if (!somenteValidar) {
                    objDados.LogradouroOutro = '';
                    objDados.BairroOutro = '';
                    objDados.CidadeOutro = '';
                    objDados.UfOutro = '';
                    objDados.PaisOutro = '';

                    this.camposObrigatorios.erroEnderecoOutroCep = false;
                    this.camposObrigatorios.erroEnderecoOutroLogradouro = false;
                    this.camposObrigatorios.erroEnderecoOutroBairro = false;
                    this.camposObrigatorios.erroEnderecoOutroCidade = false;
                    this.camposObrigatorios.erroEnderecoOutroUf = false;
                    this.camposObrigatorios.erroEnderecoOutroPais = false;

                    this.isDisabledEnderecoOutro = false;
                    this.isDisabledEnderecoOutroLogradouro = false;
                }
            } finally {
                this.isLoading = false;
            }
        },
        async validarCepComercial(objDados, somenteValidar = false) {
            this.isLoading = true;
            try {
                if (objDados.EnderecoComercialCep) {
                    var result = await validarCampoCep(objDados, { somenteValidar: somenteValidar, tipoEndereco: "EnderecoComercial" });
                    if (result) {
                        this.localPF.EnderecoComercialPais = 'BRA';
                        this.isDisabledEnderecoComercial = true;
                        this.isDisabledEnderecoComercialLogradouro = true;
                        if (objDados.EnderecoComercial == '')
                            this.isDisabledEnderecoComercialLogradouro = false;
                    } else {
                        this.isDisabledEnderecoComercial = false;
                        this.isDisabledEnderecoComercialLogradouro = false;
                    }
                }else if (!somenteValidar){
                    objDados.EnderecoComercial = '';
                    objDados.EnderecoComercialNumero = '';
                    objDados.EnderecoComercialBairro = '';
                    objDados.EnderecoComercialCidade = '';
                    objDados.EnderecoComercialEstado = '';
                    objDados.EnderecoComercialPais = '';

                    this.camposObrigatorios.erroEnderecoComercialCep = false;
                    this.camposObrigatorios.erroEnderecoComercialLogradouro = false;
                    this.camposObrigatorios.erroEnderecoComercialNumero = false;
                    this.camposObrigatorios.erroEnderecoComercialBairro = false;
                    this.camposObrigatorios.erroEnderecoComercialCidade = false;
                    this.camposObrigatorios.erroEnderecoComercialUf = false;
                    this.camposObrigatorios.erroEnderecoComercialPais = false;

                    // 👉 reabilitar os campos
                    this.isDisabledEnderecoComercial = false;
                    this.isDisabledEnderecoComercialLogradouro = false;
                }
            } finally {
                this.isLoading = false;
            }
        },
    }
}

</script>

<style scoped>
/* Loading overlay para validação de CEP */
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.spinner {
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-left-color: #000;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}
</style>